import React from "react";
import { axiosConfig } from "../../axios/axiosConfig";

export const formatSymbolName = (
  symbol,
  expiryDate,
  strikePrice,
  optionType
) => {
  if (!symbol || !expiryDate || !strikePrice || !optionType) return "";

  const formattedExpiryDate = expiryDate.replace(/-/g, "").slice(2, 8);

  const formattedStrike = Number(strikePrice).toFixed(0);

  const formattedOption = optionType.toUpperCase();

  return `${symbol.toUpperCase()}${formattedExpiryDate}${formattedStrike}${formattedOption}`;
};
